import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';

export type HousePrice = {
    id: number;
    price: SearchResponseHousePrice | null;
};

export default class HousePrices extends AbstractSubject {
    #prices: HousePrice[] = [];

    static #instance: HousePrices | null = null;

    public static getInstance(): HousePrices {
        if (!HousePrices.#instance) {
            HousePrices.#instance = new HousePrices();
        }

        return HousePrices.#instance;
    }

    get prices(): HousePrice[] {
        return this.#prices;
    }

    set prices(prices: HousePrice[]) {
        this.#prices = prices;
        this.notify();
    }
}
